import { render, staticRenderFns } from "./RegioesEntrega.vue?vue&type=template&id=64c31ef0&"
import script from "./RegioesEntrega.vue?vue&type=script&lang=js&"
export * from "./RegioesEntrega.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports